<template>
	<div class="app-tabs-container">
		<!-- AppTabSelector is hidden and not v-if'ed so AppTabs will still work -->
		<AppTabSelector :tabItems="tabItems" v-model="localValue" v-on="$listeners" :class="{ 'display-none': hideSelector }" />
		<v-tabs-items v-model="localValue">
			<v-tab-item v-for="item in tabItems" :key="item.tab">
				<v-card flat>
					<component :is="item.component" v-bind="item.props" v-on="item.listeners" />
				</v-card>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'AppTabs',
	mixins: [VModelMixin],
	props: { tabItems: { type: Array }, hideSelector: { type: Boolean } },
};
</script>

<style scoped lang="scss">
.app-tabs-container {
	height: 100%;

	::v-deep {
		.v-item-group {
			height: 100%;
		}
		.v-item-group:not(:has(.ai-assistant-factory, .transactional-emails-wrapper)) {
			height: calc(100% - 34px);
		}
		.v-window__container,
		.v-window-item,
		.v-card {
			height: 100%;
		}
		.v-card > div {
			height: 100%;
		}
	}
}
</style>
